import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  type: "info-outline",
  class: "row col-xs-12 items-center"
}
const _hoisted_2 = { class: "row justify-start col-xs-11" }
const _hoisted_3 = { class: "col-xs-12 s-form-input_wrapper wrap-anyway q-mb-sm" }
const _hoisted_4 = { class: "col-xs-12 s-form-input_wrapper wrap-anyway q-mb-sm" }
const _hoisted_5 = { class: "col-xs-12 base-margin-left wrap-anyway" }
const _hoisted_6 = { class: "col-xs-1" }

import SBtn from 'SharedComponents/ui/Button/SBtn.vue';
import SCheckbox from 'SharedComponents/ui/Checkbox/SCheckbox.vue';
import SInput from 'SharedComponents/ui/Input/SInput.vue';
import useValidation from 'SharedDir/common/composables/useValidation';
import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';

import TableRow from './table-row';

interface Props extends PropValue<TableRow | null> {
  readonly?: boolean;
  sumIsSet: boolean;
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'TableRowItem' },
  __name: 'TableRow',
  props: {
    readonly: { type: Boolean, default: false },
    sumIsSet: { type: Boolean },
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emit = __emit;
const { innerValue, emitValue } = useValue(props, emit, {
  transform: (v) => v ?? new TableRow(),
});
const { NotEmpty } = useValidation();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(SInput, {
          modelValue: _unref(innerValue).label,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(innerValue).label) = $event)),
          class: "s-form-input required",
          clearable: "",
          outlined: "",
          dense: "",
          required: "",
          "hide-bottom-space": "",
          label: "Наименование",
          readonly: _ctx.readonly,
          autocomplete: "table-rowe-label",
          rules: [_unref(NotEmpty)('Наименование обязательно для заполнения')],
          onBlur: _unref(emitValue)
        }, null, 8, ["modelValue", "readonly", "rules", "onBlur"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(SInput, {
          modelValue: _unref(innerValue).slug,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(innerValue).slug) = $event)),
          class: "s-form-input required",
          clearable: "",
          outlined: "",
          dense: "",
          required: "",
          "hide-bottom-space": "",
          label: "Служебное наименование (slug)",
          readonly: _ctx.readonly,
          autocomplete: "table-rowe-slug",
          rules: [_unref(NotEmpty)('Slug обязателен для заполнения')],
          onBlur: _unref(emitValue)
        }, null, 8, ["modelValue", "readonly", "rules", "onBlur"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(SCheckbox, {
          modelValue: _unref(innerValue).isSummary,
          "onUpdate:modelValue": [
            _cache[2] || (_cache[2] = ($event: any) => ((_unref(innerValue).isSummary) = $event)),
            _unref(emitValue)
          ],
          class: "s-form-input required",
          dense: "",
          required: "",
          "hide-bottom-space": "",
          label: "Сумма по столбцу",
          disable: _ctx.sumIsSet && _unref(innerValue).isSummary === false
        }, null, 8, ["modelValue", "disable", "onUpdate:modelValue"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(SBtn, {
        type: "icon",
        icon: "las la-trash-alt",
        tooltip: "Удаление строки",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (!_ctx.readonly && _ctx.$emit('remove')))
      })
    ])
  ]))
}
}

})